import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import { useViewerRoles } from '@treams/treams-hooks';
import { Button } from '@treams/treams-ui';

export default function InboxTaskBar(props: { always?: boolean }) {
	const { t } = useTranslation();

	const roles = useViewerRoles();

	if (!props.always && !(roles.isManager || roles.isWorkspaceSuperuser)) {
		return null;
	}

	return (
		<Flex mt={2} my={2}>
			<Button
				small
				link="/inbox/manager"
				title={roles.isWorkspaceSuperuser ? t('inbox.tabs.superuser') : t('inbox.tabs.manager')}
			/>
		</Flex>
	);
}
